const FromArr = [
  {
    title: "许可证编号",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
    X: true,
  },
  {
    title: "企业名称",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "经营方式",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "经营场所",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "库房地址",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "注册地址",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "法定代表人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "企业负责人",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "经营范围",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "发证日期",
    modelvalue: "",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "起始日期",
    modelvalue: "",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "失效日期",
    modelvalue: "",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "住所",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 580,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: -10,
  },
];
export default FromArr;
